

export const AuthLayout = ( {children, title=''} ) => {
  return (
    <div className="singUpBackground">
        <div className="singUpView">
            <div>
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M43.624 28.4804C42.4031 32.9555 32.0006 50 32.0006 50C32.0006 50 21.5981 32.9583 20.3773 28.4804C19.1675 24.036 21.456 19.3582 23.5521 17.2137C25.598 15.1165 27.6997 14.047 28.522 14.0026C29.3442 13.9609 32.2738 14.3859 29.9826 17.7804C27.6913 21.1749 23.4294 25.3027 25.3639 28.9138C26.6935 31.3971 30.1247 31.4944 30.9247 29.6916C31.287 28.8721 30.7881 27.9443 29.7233 26.6582C29.1129 25.9221 27.9645 24.8527 27.9645 23.8165C27.9645 21.8054 29.9826 21.8276 32.0034 21.8054C34.0215 21.8276 36.0423 21.8054 36.0423 23.8165C36.0423 24.8527 34.8911 25.9193 34.2835 26.6582C33.2187 27.9471 32.717 28.8721 33.0821 29.6916C33.8821 31.4944 37.3134 31.3999 38.6429 28.9138C40.5774 25.2999 36.3155 21.1749 34.0243 17.7804C31.733 14.3859 34.657 13.9637 35.4793 14.0026C36.3015 14.0443 38.4032 15.1137 40.4519 17.2109C42.5481 19.3554 44.8337 24.0332 43.6212 28.4777L43.624 28.4804Z" fill="#006667"/>
                    <rect x="0.75" y="0.75" width="62.5" height="62.5" rx="31.25" stroke="#FF8367" strokeWidth="1.5"/>
                </svg>
            </div>
            <div>
                <h1>{ title }</h1>
                <p>¡Bienvenido a <span>SniffNear</span>!</p>
            </div>

            { children }
        
        </div>

    </div>
  )
}
